module.exports = __webpack_public_path__ + "img/ach_katan_no.86aee594.png";